(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2725],{

/***/ 25426:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/metodo-pago",
      function () {
        return __webpack_require__(16948);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CheckoutPaymentMethod; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/queries/checkout/queries/paymentMethod.ts
var paymentMethod = __webpack_require__(66003);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/paymentMethodStore.tsx
var paymentMethodStore = __webpack_require__(69355);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/styles.ts
var styles = __webpack_require__(52595);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Switch/Switch.js
var Switch = __webpack_require__(16056);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/SwitchCard.styles.ts


var SwitchCardLabel = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    fontWeight: "500",
    fontFamily: "Poppins",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var SwitchCardSwitch = (0,styled/* default */.Z)(Switch/* default */.Z)({
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#0A7ABE"
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#AFD5FF"
    }
});

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/SwitchCard.tsx




var SwitchCard = function(param) {
    var label = param.label, onChange = param.onChange, checked = param.checked, loading = param.loading;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchCardSkeleton, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PaymentMethodMiniCard */.b, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchCardLabel, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchCardSwitch, {
                onChange: onChange,
                checked: checked
            })
        ]
    });
};
var SwitchCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PaymentMethodMiniCard */.b, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 120,
                height: 22
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 50,
                height: 38
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/MekiCredits.tsx
// import { useEffect } from 'react';










function MekiCredits(param) {
    var loading = param.loading;
    var track = (0,useSegment/* useSegment */.K)().track;
    var orderUuid = (0,useOrderState/* useOrderState */.h)().orderUuid;
    var ref = (0,paymentMethodStore/* usePaymentSelectors */.M6)(), checked = ref.mekiCreditsChecked;
    var setMekiCreditsChecked = (0,paymentMethodStore/* usePaymentMethodActions */.pu)().setMekiCreditsChecked;
    var setInsuranceId = (0,useMekiState/* useMekiState */.c)().setInsuranceId;
    var ref1 = (0,useQuery/* useQuery */.a)((0,paymentMethod/* getCheckoutPaymentMethod */.k)(), {
        fetchPolicy: "cache-first",
        variables: {
            params: {
                orderUuid: orderUuid
            }
        }
    }), orderAndUserInfoData = ref1.data;
    var currentUserInfo = (orderAndUserInfoData !== null && orderAndUserInfoData !== void 0 ? orderAndUserInfoData : {}).currentUserInfo;
    var ref2;
    var credits = (ref2 = currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits) !== null && ref2 !== void 0 ? ref2 : 0;
    var handleMekiCreditsChange = function(event) {
        setMekiCreditsChecked(event.target.checked);
        setInsuranceId(null);
        track("change credits use", {
            activated: event.target.checked
        });
    };
    var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    var label = "Cr\xe9ditos Meki: ".concat(credits === 0 ? "$0" : currencyFormatter.format(credits));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchCard, {
        label: label,
        onChange: handleMekiCreditsChange,
        checked: checked,
        loading: loading
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/InsuranceOptions.styles.ts




var RootDiv = (0,styled/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "hidden" && prop !== "childAmount";
    }
})(function(param) {
    var hidden = param.hidden, childAmount = param.childAmount, theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        border: "1px solid #EAEAEA",
        borderRadius: "10px",
        height: hidden ? "0px" : "calc(84px + ".concat(childAmount, " * 64px)"),
        padding: hidden ? "0px 15px 0px 15px" : "15px 15px 8px 15px",
        opacity: hidden ? 0 : 1,
        marginTop: hidden ? "0px" : "15px",
        transition: "all 0.3s ease-in",
        "& > *": {
            opacity: hidden ? 0 : 1,
            transition: "all 0.3s ease-in"
        }
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(375), {
        height: hidden ? "0px" : "calc(63px + ".concat(childAmount, " * 84px)")
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(258), {
        height: hidden ? "0px" : "calc(87px + ".concat(childAmount, " * 84px)")
    }), _obj;
});
var InsuranceItem = (0,styled/* default */.Z)("div")({
    display: "flex",
    padding: "10px 0px",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
});
var InsuranceSubItem = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    gap: "10px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.16px",
    textAlign: "left"
});
var CheckIconContainer = (0,styled/* default */.Z)("div")({
    position: "relative",
    width: "24px",
    height: "24px",
    marginTop: "10px"
});
var InformationTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "#757475",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    transition: "color 0.3s ease-in-out"
});
var TextContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        gap: "2px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(400), {
        maxWidth: "50vw"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(300), {
        maxWidth: "40vw"
    }), _obj;
});
var SwitchButton = (0,styled/* default */.Z)(Switch/* default */.Z)({
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#0A7ABE"
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#AFD5FF"
    }
});
var AddInsurance = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    cursor: "pointer"
});
var AddInsuranceContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1px",
    justifyContent: "flex-start",
    marginTop: "10px",
    marginBottom: "5px",
    cursor: "pointer"
});
var IconContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    cursor: "pointer"
});
var LoaderContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    marginRight: 18
});
var InsuranceSkeletonContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "15px"
});
var AddInsuranceTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0.16px",
    color: "#0A7ABE"
});


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./src/hooks/useModalRouter.ts
var useModalRouter = __webpack_require__(9006);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./src/screens/insurance/my-insurances/styles.ts
var my_insurances_styles = __webpack_require__(47440);
// EXTERNAL MODULE: ./src/components/Reminders/reminderCardSkeleton.styles.ts
var reminderCardSkeleton_styles = __webpack_require__(19906);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/PaymentsOptions.styles.ts
var PaymentsOptions_styles = __webpack_require__(96966);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/InsuranceOptions.tsx


















function InsuranceOptions(props) {
    var loadingInsurances = props.loadingInsurances, loadInsuranceQuote = props.loadInsuranceQuote, loadingCircle = props.loadingCircle, userInsurances = props.userInsurances, quoteError = props.quoteError;
    var setMekiCreditsChecked = (0,paymentMethodStore/* usePaymentMethodActions */.pu)().setMekiCreditsChecked;
    var ref = (0,react.useState)(false), showLoader = ref[0], setShowLoader = ref[1];
    var ref1 = (0,react.useState)(null), insuranceClicked = ref1[0], setInsuranceClicked = ref1[1];
    var ref2 = (0,useMekiState/* useMekiState */.c)(), insuranceId = ref2.insuranceId, setInsuranceId = ref2.setInsuranceId, setInsuranceRut = ref2.setInsuranceRut;
    var ref3 = (0,useAuth/* useAuth */.a)(), user = ref3.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var modalRouter = (0,useModalRouter/* useModalRouter */.r)();
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var ref4;
    var isPermittedUser = !environment/* INSURANCE_EMAILS_ALLOWED */.Ii ? true : environment/* INSURANCE_EMAILS_ALLOWED.includes */.Ii.includes((ref4 = user === null || user === void 0 ? void 0 : user.email) !== null && ref4 !== void 0 ? ref4 : "");
    var selectedInsurance = (0,react.useMemo)(function() {
        return userInsurances.find(function(insurance) {
            return insurance.id === insuranceId;
        });
    }, [
        userInsurances,
        insuranceId
    ]);
    var handleInsuranceChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var selected, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ((selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.id) === id) {
                            setInsuranceId(null);
                            setInsuranceClicked(null);
                            setMekiCreditsChecked(false);
                            return [
                                2
                            ];
                        }
                        setInsuranceClicked(id);
                        setShowLoader(true);
                        selected = userInsurances.find(function(insurance) {
                            return insurance.id === id;
                        });
                        if (!selected) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setInsuranceId(id);
                        setMekiCreditsChecked(false);
                        setInsuranceRut(selected.rut);
                        return [
                            4,
                            loadInsuranceQuote(selected.rut)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        utils/* Console.error */.Mn.error("Error loading insurance quote:", err);
                        setInsuranceId(null);
                        setInsuranceClicked(null);
                        setMekiCreditsChecked(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setShowLoader(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleInsuranceChange(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var insuranceAmount = (0,react.useMemo)(function() {
        return (userInsurances === null || userInsurances === void 0 ? void 0 : userInsurances.length) || 0;
    }, [
        userInsurances
    ]);
    var insuranceRedirect = function() {
        if (isLocalVendor) {
            return void modalRouter.push((0,utils/* getRoute */.Bv)("insuranceIntroduction", {
                from: "checkout",
                redirect: "checkoutPaymentMethodLocal"
            }));
        }
        return void modalRouter.push((0,utils/* getRoute */.Bv)("insuranceIntroduction", {
            from: "checkout",
            redirect: "checkoutPaymentMethod"
        }));
    };
    var sortedUserInsurancesByDate = (0,react.useMemo)(function() {
        return userInsurances.sort(function(a, b) {
            return new Date(b.usedAt).getTime() - new Date(a.usedAt).getTime();
        });
    }, [
        userInsurances
    ]);
    (0,react.useEffect)(function() {
        if (quoteError) {
            setInsuranceId(null);
            setInsuranceClicked(null);
        }
    }, [
        quoteError
    ]);
    if (!isPermittedUser) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !loadingInsurances ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
                hidden: false,
                childAmount: insuranceAmount,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                        children: "Seguro complementario"
                    }),
                    sortedUserInsurancesByDate.map(function(insurance) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsuranceItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationTypography, {
                                                    children: insurance.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationTypography, {
                                                    children: insurance.rut
                                                })
                                            ]
                                        }),
                                        (showLoader || loadingCircle) && insuranceClicked === insurance.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                size: 25,
                                                thickness: 4,
                                                color: "primary"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                                            onChange: function() {
                                                void handleInsuranceChange(insurance.id);
                                            },
                                            checked: insuranceId && insuranceId === insurance.id
                                        })
                                    ]
                                }, insurance.id),
                                insuranceAmount != 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                            ]
                        }, insurance.id);
                    }),
                    insuranceAmount >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            insuranceAmount == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddInsuranceContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                            color: "primary",
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddInsuranceTypography, {
                                        onClick: insuranceRedirect,
                                        children: "Agregar otro seguro/beneficiario"
                                    })
                                ]
                            })
                        ]
                    }),
                    insuranceAmount == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddInsuranceContainer, {
                        onClick: insuranceRedirect,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "primary",
                                    fontSize: "small"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddInsuranceTypography, {
                                children: "Agregar seguro/beneficiario"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceSkeletonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(my_insurances_styles/* SkeletonContainer */.Fh, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reminderCardSkeleton_styles/* StyledSkeleton */.ps, {
                            variant: "rectangular",
                            width: "10%",
                            height: 10,
                            style: {
                                margin: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reminderCardSkeleton_styles/* StyledSkeleton */.ps, {
                            variant: "rectangular",
                            width: "30%",
                            height: 10,
                            style: {
                                margin: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reminderCardSkeleton_styles/* StyledSkeleton */.ps, {
                            variant: "rectangular",
                            width: "15%",
                            height: 10,
                            style: {
                                margin: 0
                            }
                        })
                    ]
                })
            }),
            quoteError && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ErrorTypography */.Os, {
                children: "No se pudo obtener la cotizaci\xf3n del seguro. Intente m\xe1s tarde."
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/PaymentsOptions.tsx + 5 modules
var PaymentsOptions = __webpack_require__(84895);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/assistantPaymentOptionsStore.tsx
var assistantPaymentOptionsStore = __webpack_require__(82031);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/AssistantPaymentSwitch.tsx




function AssistantPaymentSwitch(param) {
    var label = param.label, loading = param.loading;
    var track = (0,useSegment/* useSegment */.K)().track;
    var ref = (0,assistantPaymentOptionsStore/* useAssistantPaymentOptions */.S)(), sendEmail = ref.sendEmail, chargeDeliveryCost = ref.chargeDeliveryCost;
    var ref1 = (0,assistantPaymentOptionsStore/* useAssistantPaymentActions */.M)(), setSendEmail = ref1.setSendEmail, setChargeDeliveryCost = ref1.setChargeDeliveryCost;
    var handleChangeSkipDeliveryCost = function(event) {
        setChargeDeliveryCost(event.target.checked);
        track("change charge delivery cost", {
            activated: event.target.checked
        });
    };
    var handleChangeSendEmail = function(event) {
        setSendEmail(event.target.checked);
        track("change send email", {
            activated: event.target.checked
        });
    };
    var onChange = label == "Enviar email" ? handleChangeSendEmail : handleChangeSkipDeliveryCost;
    var checked = label == "Enviar email" ? sendEmail : chargeDeliveryCost;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchCard, {
        label: label,
        onChange: onChange,
        checked: checked,
        loading: loading
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/PaymentTotalBanner.styles.ts



var PaymentTotalBannerMain = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        margin: "0px -24px",
        width: "100vw",
        marginLeft: "-50vw",
        left: "50%",
        position: "relative",
        marginTop: "-16px"
    }, theme.breakpoints.up("sm"), {
        marginTop: "-24px"
    });
});
var PayAmountTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 600,
    lineHeight: "19px",
    color: "#414046"
});
var PayAmountDiscountTypography = (0,styled/* default */.Z)(PayAmountTypography)({
    fontWeight: 400,
    color: "#757475",
    textDecoration: "line-through",
    marginRight: "8px"
});
var PayAmountContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    padding: "16px 16px"
});
var PaymentTotalBanner_styles_AddInsuranceTypography = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "underline";
    }
})(function(param) {
    var underline = param.underline;
    return {
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "18px",
        color: underline ? "#0277BD" : "#414046",
        cursor: underline ? "pointer" : "default",
        textDecoration: underline ? "underline" : "none"
    };
});
var PaymentTotalBanner_styles_AddInsuranceContainer = (0,styled/* default */.Z)("div")({
    gap: "4px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    padding: "12px 16px",
    width: "100%"
});
var HorizontalLine = (0,styled/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "width";
    }
})(function(param) {
    var width = param.width;
    return {
        width: width ? "".concat(width, "%") : "100%",
        height: "1px",
        backgroundColor: "#EAEAEA"
    };
});
var AmountContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
});
var SkeletonTotalPriceText = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "42px",
    height: "20px",
    borderRadius: "4px"
});

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/PaymentTotalBanner.tsx









var PaymentTotalBanner = function(param) {
    var payAmount = param.payAmount, userHasInsurances = param.userHasInsurances, quoteLoading = param.quoteLoading;
    var ref = (0,useAuth/* useAuth */.a)(), user = ref.appUser;
    var modalRouter = (0,useModalRouter/* useModalRouter */.r)();
    var ref1;
    var isPermittedUser = !environment/* INSURANCE_EMAILS_ALLOWED */.Ii ? true : environment/* INSURANCE_EMAILS_ALLOWED.includes */.Ii.includes((ref1 = user === null || user === void 0 ? void 0 : user.email) !== null && ref1 !== void 0 ? ref1 : "");
    var ref2 = (0,paymentMethodStore/* useOrderAndPaymentInfo */.oF)(), originalAmount = ref2.ordersTotal;
    var handleCreateInsurance = function() {
        void modalRouter.push((0,utils/* getRoute */.Bv)("insuranceIntroduction", {
            from: "checkout",
            redirect: "checkoutPaymentMethod"
        }));
    };
    var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentTotalBannerMain, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PayAmountContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PayAmountTypography, {
                    children: "Total a pagar:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountContainer, {
                    children: [
                        originalAmount != payAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(PayAmountDiscountTypography, {
                            children: currencyFormatter.format(originalAmount)
                        }),
                        quoteLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonTotalPriceText, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PayAmountTypography, {
                            children: payAmount == 0 ? "$0" : currencyFormatter.format(payAmount)
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/queries/userInsurance/queries/getUserInsurances.ts
var getUserInsurances = __webpack_require__(20641);
// EXTERNAL MODULE: ./src/queries/userInsurance/queries/getInsuranceQuote.ts
var getInsuranceQuote = __webpack_require__(81993);
// EXTERNAL MODULE: ./src/queries/checkout/queries/detail.ts
var detail = __webpack_require__(45482);
// EXTERNAL MODULE: ./src/queries/checkout/mutations/assignPaymentMethod.tsx
var assignPaymentMethod = __webpack_require__(50952);
// EXTERNAL MODULE: ./src/queries/order/mutations/setCheckoutOrderData.tsx
var setCheckoutOrderData = __webpack_require__(43013);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/localPaymentOptionsStore.tsx
var localPaymentOptionsStore = __webpack_require__(57500);
// EXTERNAL MODULE: ./src/components/Loader.tsx
var Loader = __webpack_require__(76931);
// EXTERNAL MODULE: ./src/hooks/usePendingPrescriptions.ts + 1 modules
var usePendingPrescriptions = __webpack_require__(3618);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/PageWrapper.tsx
var PageWrapper = __webpack_require__(73362);
// EXTERNAL MODULE: ./src/components/Header/SimpleHeader.tsx + 1 modules
var SimpleHeader = __webpack_require__(45629);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/screens/checkout/styles.ts
var checkout_styles = __webpack_require__(58055);
// EXTERNAL MODULE: ./src/screens/checkout/components/Title.tsx
var Title = __webpack_require__(79728);
// EXTERNAL MODULE: ./src/screens/checkout/delivery/components/PickUpOptions.styles.ts
var PickUpOptions_styles = __webpack_require__(54760);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/InsuranceInfo.styles.ts



var InsuranceInfoDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        alignItems: "center",
        height: "40px",
        padding: "5px 5px 5px 22px",
        marginTop: "12px",
        backgroundColor: "#E6F3FA",
        transition: "all 0.3s ease-in-out"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        height: "60px"
    }), (0,_define_property/* default */.Z)(_obj, "& *", {
        opacity: 1,
        transition: "opacity 0.3s ease-in-out"
    }), _obj;
});
var InsuranceInfoIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)({
    padding: "0",
    marginRight: "17px",
    color: "#414046"
});
var InsuranceInfoTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "15.6px",
    letterSpacing: "0.15px",
    color: "#414046",
    span: {
        fontWeight: 500
    }
});

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/InsuranceInfo.tsx




var InsuranceInfo = function(param) {
    var productsWithInsuranceQuantity = param.productsWithInsuranceQuantity, orderDetailsAmount = param.orderDetailsAmount, payAmount = param.payAmount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsuranceInfoDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PickUpOptions_styles/* InfoIconButton */.JE, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {})
            }),
            productsWithInsuranceQuantity == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceInfoTypography, {
                children: "Tu seguro no cubre ninguno de los productos agregados al carro."
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsuranceInfoTypography, {
                children: [
                    orderDetailsAmount == productsWithInsuranceQuantity ? "Todos tus productos tienen cobertura." : productsWithInsuranceQuantity == 1 ? "\n                      ".concat(productsWithInsuranceQuantity, " de tus productos tiene cobertura.") : "".concat(productsWithInsuranceQuantity, " de tus productos tienen cobertura."),
                    " ",
                    payAmount != 0 ? "Selecciona un m\xe9todo de pago para ver m\xe1s detalles." : ""
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/FormComponents.ts
var FormComponents = __webpack_require__(61912);
// EXTERNAL MODULE: ./src/screens/checkout/components/OrderSummary.tsx
var OrderSummary = __webpack_require__(42737);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(8002);
// EXTERNAL MODULE: ./src/screens/checkout/utils/getDeliveryCosts.ts
var getDeliveryCosts = __webpack_require__(4999);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/index.tsx










































function CheckoutPaymentMethodPage() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    var track = (0,useSegment/* useSegment */.K)().track;
    var isDesktop = (0,useWindowSize/* useWindowSize */.i)().isDesktop;
    var ref7 = (0,useAuth/* useAuth */.a)(), user = ref7.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var ref8 = (0,useOrderState/* useOrderState */.h)(), refetchOrder = ref8.refetch, orderUuid = ref8.orderUuid, orderStatus = ref8.orderStatus, currentOrder = ref8.order;
    // Zustand
    var ref9 = (0,paymentMethodStore/* usePaymentSelectors */.M6)(), mekiCreditsChecked = ref9.mekiCreditsChecked, totalReimbursement = ref9.totalReimbursement, totalDeductible = ref9.totalDeductible;
    var ref10 = (0,useMekiState/* useMekiState */.c)(), insuranceId = ref10.insuranceId, setInsuranceId = ref10.setInsuranceId, setInsuranceRut = ref10.setInsuranceRut;
    var ref11 = (0,paymentMethodStore/* usePaymentMethodActions */.pu)(), setOrders = ref11.setOrders, setOrdersTotal = ref11.setOrdersTotal, setPaymentMethods = ref11.setPaymentMethods, setInsuranceTotalInfo = ref11.setInsuranceTotalInfo, setMekiCreditsChecked = ref11.setMekiCreditsChecked;
    var ref12 = (0,assistantPaymentOptionsStore/* useAssistantPaymentOptions */.S)(), sendEmail = ref12.sendEmail, AssistantChargeDeliveryCost = ref12.chargeDeliveryCost;
    var setChargeDeliveryCost = (0,assistantPaymentOptionsStore/* useAssistantPaymentActions */.M)().setChargeDeliveryCost;
    var paymentOption = (0,localPaymentOptionsStore/* useLocalPaymentOption */.Z)().paymentOption;
    var requirePrescriptions = (0,usePendingPrescriptions/* usePendingPrescriptions */.h)().requirePrescriptions;
    var ref13 = (0,react.useState)(0), payAmount = ref13[0], setPayAmount = ref13[1];
    var ref14 = (0,react.useState)(false), redirecting = ref14[0], setRedirecting = ref14[1];
    var ref15 = (0,react.useState)(false), quoteLoading = ref15[0], setQuoteLoading = ref15[1];
    var ref16;
    var chargeDeliveryCost = isAssistantUser ? AssistantChargeDeliveryCost !== null && AssistantChargeDeliveryCost !== void 0 ? AssistantChargeDeliveryCost : true : (ref16 = currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : ref.chargeDeliveryCost) !== null && ref16 !== void 0 ? ref16 : true;
    // Queries
    var ref17 = (0,useQuery/* useQuery */.a)((0,paymentMethod/* getCheckoutPaymentMethod */.k)(), {
        variables: {
            params: {
                orderUuid: orderUuid
            }
        },
        fetchPolicy: "cache-first"
    }), orderAndUserInfoData = ref17.data, loadingMethod = ref17.loading;
    var ref18 = orderAndUserInfoData !== null && orderAndUserInfoData !== void 0 ? orderAndUserInfoData : {}, currentUserInfo = ref18.currentUserInfo, paymentMethods = ref18.paymentMethods;
    var ref19 = (0,useQuery/* useQuery */.a)((0,detail/* OrderDeliveryOptions */.J)(), {
        variables: {
            params: {
                orderUuid: orderUuid
            }
        },
        fetchPolicy: "cache-and-network"
    }), tmp = ref19.data, orderDeliveryOptions = (tmp === void 0 ? {} : tmp).orderDeliveryOptions, loadingDeliveryOptions = ref19.loading;
    var ref20 = (0,useQuery/* useQuery */.a)((0,getUserInsurances/* getUserInsurances */.D)(), {
        fetchPolicy: "cache-and-network",
        variables: {
            params: {
                userId: user === null || user === void 0 ? void 0 : user.id
            }
        }
    }), insurancesData = ref20.data, loadingInsurances = ref20.loading;
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,getInsuranceQuote/* getInsuranceQuote */.H)(), {
        fetchPolicy: "no-cache"
    }), 2), getInsuranceQuoteLazy = ref21[0], ref22 = ref21[1], quoteData = ref22.data, loadingGetInsuranceQuote = ref22.loading, insuranceQuoteError = ref22.error;
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,setCheckoutOrderData/* setCheckoutOrderData */.r)()), 1), setCheckoutData = ref23[0];
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,assignPaymentMethod/* assignPaymentMethod */.n)()), 1), assignMethod = ref24[0];
    var loadInsuranceQuote = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(rut) {
            var quoteDataResponse, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (orderStatus != "DRAFT") {
                            utils/* Console.log */.Mn.log("loadInsuranceQuote not ran. Order status is not DRAFT");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setQuoteLoading(true);
                        return [
                            4,
                            getInsuranceQuoteLazy({
                                variables: {
                                    params: {
                                        rut: rut
                                    }
                                }
                            })
                        ];
                    case 2:
                        quoteDataResponse = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        utils/* Console.log */.Mn.log("Loading insurance quote failed", error);
                        throw error;
                    case 4:
                        setQuoteLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(rut) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getInsuranceQuoteLazy,
        orderStatus
    ]);
    var userHasInsurances = (0,react.useMemo)(function() {
        var ref;
        return Boolean(user === null || user === void 0 ? void 0 : user.hasUserInsurance) && (insurancesData === null || insurancesData === void 0 ? void 0 : (ref = insurancesData.getUserInsurances) === null || ref === void 0 ? void 0 : ref.length) > 0;
    }, [
        user === null || user === void 0 ? void 0 : user.hasUserInsurance,
        insurancesData === null || insurancesData === void 0 ? void 0 : (ref1 = insurancesData.getUserInsurances) === null || ref1 === void 0 ? void 0 : ref1.length
    ]);
    var selectedDeliveryOption = orderDeliveryOptions === null || orderDeliveryOptions === void 0 ? void 0 : orderDeliveryOptions.find(function(item) {
        return item.dates.length === ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderGroupId) ? 2 : 1);
    });
    var orders = selectedDeliveryOption === null || selectedDeliveryOption === void 0 ? void 0 : selectedDeliveryOption.orders;
    var orderDetailsAmount = orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
        return acc + order.orderDetails.length;
    }, 0);
    var ordersTotal = (0,react.useMemo)(function() {
        var ref;
        return (ref = orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
            var orderTotal = order.orderDetails.reduce(function(acc, detail) {
                return acc + detail.quantity * detail.price;
            }, 0);
            if (!chargeDeliveryCost && isAssistantUser) {
                return acc + orderTotal;
            }
            return acc + orderTotal + (chargeDeliveryCost ? order.deliveryCost : 0);
        }, 0)) !== null && ref !== void 0 ? ref : 0;
    }, [
        chargeDeliveryCost,
        isAssistantUser,
        orders
    ]);
    var ref25, ref26;
    var ref27 = !chargeDeliveryCost && isAssistantUser || !selectedDeliveryOption ? {
        deliveryCost: 0,
        oldDeliveryCost: 0
    } : (0,getDeliveryCosts/* getDeliveryCosts */.U)({
        orders: (ref25 = selectedDeliveryOption === null || selectedDeliveryOption === void 0 ? void 0 : selectedDeliveryOption.orders) !== null && ref25 !== void 0 ? ref25 : [],
        deliveryCost: (ref26 = selectedDeliveryOption === null || selectedDeliveryOption === void 0 ? void 0 : selectedDeliveryOption.deliveryCost) !== null && ref26 !== void 0 ? ref26 : constants/* DELIVERY_COST */.fI
    }), deliveryCost = ref27.deliveryCost, oldDeliveryCost = ref27.oldDeliveryCost;
    var isDelivery = (orderDeliveryOptions === null || orderDeliveryOptions === void 0 ? void 0 : (ref2 = orderDeliveryOptions[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.orders) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.deliveryType) === "DELIVERY";
    var assignOrderMetadata = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, claimId, userInsuranceId, totalReimbursement, totalDeductible, totalCopay, reimbursedProducts, cleanReimbursedProducts, ref4;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref3 = (ref2 = quoteData === null || quoteData === void 0 ? void 0 : quoteData.getInsuranceQuote) !== null && ref2 !== void 0 ? ref2 : {}, claimId = ref3.claimId, userInsuranceId = ref3.insuranceId, totalReimbursement = ref3.totalReimbursement, totalDeductible = ref3.totalDeductible, totalCopay = ref3.totalCopay, reimbursedProducts = ref3.reimbursedProducts;
                    cleanReimbursedProducts = reimbursedProducts === null || reimbursedProducts === void 0 ? void 0 : reimbursedProducts.map(function(product) {
                        if (product.coverage) {
                            return {
                                sku: +product.sku,
                                observation: product.observation,
                                unitReimbursement: product.unitReimbursement,
                                unitDeductible: product.unitDeductible,
                                unitCopay: product.unitCopay,
                                quantity: product.quantity,
                                coverage: product.coverage
                            };
                        }
                    });
                    return [
                        4,
                        setCheckoutData({
                            variables: {
                                params: {
                                    orderId: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                    replace: false,
                                    metadata: {
                                        useMekiCredits: mekiCreditsChecked !== null && mekiCreditsChecked !== void 0 ? mekiCreditsChecked : false,
                                        chargeDeliveryCost: chargeDeliveryCost !== null && chargeDeliveryCost !== void 0 ? chargeDeliveryCost : true,
                                        insuranceInfo: !insuranceId ? null : {
                                            claimId: +claimId,
                                            rut: (ref4 = quoteData === null || quoteData === void 0 ? void 0 : (ref = quoteData.getInsuranceQuote) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.rut) !== null && ref4 !== void 0 ? ref4 : "",
                                            insuranceId: userInsuranceId !== null && userInsuranceId !== void 0 ? userInsuranceId : null,
                                            totalReimbursement: totalReimbursement !== null && totalReimbursement !== void 0 ? totalReimbursement : 0,
                                            totalDeductible: totalDeductible !== null && totalDeductible !== void 0 ? totalDeductible : 0,
                                            totalCopay: totalCopay !== null && totalCopay !== void 0 ? totalCopay : 0,
                                            reimbursedProducts: cleanReimbursedProducts !== null && cleanReimbursedProducts !== void 0 ? cleanReimbursedProducts : []
                                        },
                                        localVendor: null,
                                        assistantVendor: isAssistantUser ? {
                                            paymentMethod: paymentOption
                                        } : null,
                                        sendEmail: sendEmail !== null && sendEmail !== void 0 ? sendEmail : true,
                                        userInfo: null,
                                        installments: 0
                                    }
                                }
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        refetchOrder()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        quoteData === null || quoteData === void 0 ? void 0 : quoteData.getInsuranceQuote,
        setCheckoutData,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        mekiCreditsChecked,
        chargeDeliveryCost,
        insuranceId,
        isAssistantUser,
        paymentOption,
        sendEmail,
        refetchOrder, 
    ]);
    var handleNext = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(intallmentsRedirect) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setRedirecting(true);
                        return [
                            4,
                            assignOrderMetadata()
                        ];
                    case 1:
                        _state.sent();
                        if (intallmentsRedirect && payAmount > 0) {
                            void router.push((0,utils/* getRoute */.Bv)("checkoutInstallments"));
                            return [
                                2
                            ];
                        }
                        if (requirePrescriptions) {
                            void router.push((0,utils/* getRoute */.Bv)("checkoutPrescriptions"));
                            return [
                                2
                            ];
                        }
                        void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentConfirm"));
                        return [
                            2
                        ];
                }
            });
        });
        return function(intallmentsRedirect) {
            return _ref.apply(this, arguments);
        };
    }(), [
        assignOrderMetadata,
        router,
        payAmount,
        requirePrescriptions
    ]);
    var handleBack = (0,react.useCallback)(function() {
        void router.replace((0,utils/* getRoute */.Bv)("checkoutDetail").toString());
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        if ((currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits) === 0 || userHasInsurances) {
            setMekiCreditsChecked(false);
        }
    }, [
        currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits,
        setMekiCreditsChecked,
        userHasInsurances
    ]);
    (0,react.useEffect)(function savePaymentMethodsValue() {
        setPaymentMethods(paymentMethods);
    }, [
        paymentMethods,
        setPaymentMethods
    ]);
    (0,react.useEffect)(function setZustandInitialValues() {
        setChargeDeliveryCost(isLocalVendor || deliveryCost == 0 ? false : true);
    }, [
        deliveryCost,
        isLocalVendor,
        setChargeDeliveryCost
    ]);
    (0,react.useEffect)(function refreshOrderTotalPayAmount() {
        setOrders(orders);
        setOrdersTotal(ordersTotal);
    }, [
        orders,
        ordersTotal,
        setOrders,
        setOrdersTotal
    ]);
    (0,react.useEffect)(function refreshTotalReimbursement() {
        var ref, ref1, ref2;
        var ref3, ref4, ref5;
        setInsuranceTotalInfo({
            insuranceId: insuranceId,
            totalReimbursement: (ref3 = quoteData === null || quoteData === void 0 ? void 0 : (ref = quoteData.getInsuranceQuote) === null || ref === void 0 ? void 0 : ref.totalReimbursement) !== null && ref3 !== void 0 ? ref3 : 0,
            totalDeductible: (ref4 = quoteData === null || quoteData === void 0 ? void 0 : (ref1 = quoteData.getInsuranceQuote) === null || ref1 === void 0 ? void 0 : ref1.totalDeductible) !== null && ref4 !== void 0 ? ref4 : 0,
            totalCopay: (ref5 = quoteData === null || quoteData === void 0 ? void 0 : (ref2 = quoteData.getInsuranceQuote) === null || ref2 === void 0 ? void 0 : ref2.totalCopay) !== null && ref5 !== void 0 ? ref5 : 0
        });
    }, [
        insuranceId,
        quoteData === null || quoteData === void 0 ? void 0 : quoteData.getInsuranceQuote,
        setInsuranceTotalInfo
    ]);
    var contentLoading = loadingDeliveryOptions || loadingMethod || !orderDeliveryOptions || quoteLoading;
    (0,react.useEffect)(function() {
        if (!mekiCreditsChecked && payAmount === 0 && !contentLoading) {
            var assingMekiCreditPaymentMethod = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    assignMethod({
                                        variables: {
                                            params: {
                                                orderUuid: orderUuid,
                                                paymentMethodUuid: "00000000-0000-0000-0000-00000006"
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                assignPaymentMethod: {
                                                    __typename: "Order",
                                                    id: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                                    uuid: orderUuid,
                                                    paymentMethod: {
                                                        id: -7
                                                    }
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function assingMekiCreditPaymentMethod() {
                    return _ref.apply(this, arguments);
                };
            }();
            void assingMekiCreditPaymentMethod();
            void track("add payment succeed", {
                payment_method_type: "INSURANCE",
                userId: user === null || user === void 0 ? void 0 : user.id
            });
        }
        if (mekiCreditsChecked && payAmount === 0) {
            var assingMekiCreditPaymentMethod1 = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    assignMethod({
                                        variables: {
                                            params: {
                                                orderUuid: orderUuid,
                                                paymentMethodUuid: "00000000-0000-0000-0000-00000000"
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                assignPaymentMethod: {
                                                    __typename: "Order",
                                                    id: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                                    uuid: orderUuid,
                                                    paymentMethod: {
                                                        id: -1
                                                    }
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function assingMekiCreditPaymentMethod1() {
                    return _ref.apply(this, arguments);
                };
            }();
            void assingMekiCreditPaymentMethod1();
            void track("add payment succeed", {
                payment_method_type: "MEKI_CREDIT",
                userId: user === null || user === void 0 ? void 0 : user.id
            });
        }
    }, [
        mekiCreditsChecked,
        assignMethod,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        orderUuid,
        track,
        payAmount,
        user === null || user === void 0 ? void 0 : user.id, 
    ]);
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, mostRecentInsurance, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((insurancesData === null || insurancesData === void 0 ? void 0 : (ref = insurancesData.getUserInsurances) === null || ref === void 0 ? void 0 : ref.length) !== 0)) return [
                                3,
                                4
                            ];
                            mostRecentInsurance = insurancesData === null || insurancesData === void 0 ? void 0 : (ref1 = insurancesData.getUserInsurances) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(latest, current) {
                                return new Date(current.usedAt) > new Date(latest.usedAt) ? current : latest;
                            });
                            if (!mostRecentInsurance) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            setInsuranceId(mostRecentInsurance.id);
                            setInsuranceRut(mostRecentInsurance.rut);
                            return [
                                4,
                                loadInsuranceQuote(mostRecentInsurance === null || mostRecentInsurance === void 0 ? void 0 : mostRecentInsurance.rut)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            setInsuranceId(null);
                            setInsuranceRut(null);
                            utils/* Console.log */.Mn.log("Loading insurance quote failed", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        void fetchData();
    }, [
        insurancesData === null || insurancesData === void 0 ? void 0 : insurancesData.getUserInsurances,
        setInsuranceId,
        setInsuranceRut,
        loadInsuranceQuote, 
    ]);
    (0,react.useEffect)(function() {
        var finalReimbursement = (totalReimbursement !== null && totalReimbursement !== void 0 ? totalReimbursement : 0) - (totalDeductible !== null && totalDeductible !== void 0 ? totalDeductible : 0);
        var ordersTotalFinal = mekiCreditsChecked ? Math.max(ordersTotal - (currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits), 0) : insuranceId ? ordersTotal - finalReimbursement : ordersTotal;
        setPayAmount(ordersTotalFinal);
    }, [
        mekiCreditsChecked,
        ordersTotal,
        quoteData,
        currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits,
        currentUserInfo,
        totalReimbursement,
        insuranceId,
        totalDeductible, 
    ]);
    var showNextButton = mekiCreditsChecked && payAmount == 0 || isAssistantUser && paymentOption == "TRANSFER" || !mekiCreditsChecked && payAmount == 0;
    var reimbursedProductIds = quoteData === null || quoteData === void 0 ? void 0 : (ref5 = quoteData.getInsuranceQuote) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.reimbursedProducts) === null || ref6 === void 0 ? void 0 : ref6.map(function(product) {
        return +product.sku;
    });
    var ref28;
    var productsWithInsuranceQuantity = (ref28 = reimbursedProductIds === null || reimbursedProductIds === void 0 ? void 0 : reimbursedProductIds.length) !== null && ref28 !== void 0 ? ref28 : 0;
    var showInsuranceOptions = !mekiCreditsChecked || (currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits) == 0;
    var headerTitle = !isDesktop ? "M\xe9todo de pago" : null;
    var userHasCredits = (currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits) > 0 || loadingMethod;
    var showInsuranceInfo = userHasInsurances && insuranceId && !insuranceQuoteError && !quoteLoading;
    var showCreditsOrInsuranceInfo = mekiCreditsChecked && userHasInsurances && !contentLoading;
    var ref29;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* BackgroundGlobalStyle */.m, {
                mobileColor: "gray"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHeader/* SimpleHeader */.A, {
                title: headerTitle,
                homeButton: isDesktop,
                backButton: true,
                handleBack: handleBack,
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* PageWrapper */.F, {
                addHeaderPadding: false,
                disableMobilePadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(checkout_styles/* HorizontalContainer */.bp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(checkout_styles/* CheckoutCardsContainer */.Q9, {
                            children: [
                                !isAssistantUser && !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentTotalBanner, {
                                    payAmount: payAmount,
                                    userHasInsurances: userHasInsurances,
                                    quoteLoading: quoteLoading
                                }),
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* CheckoutTitle */.A, {
                                    title: "Selecciona m\xe9todo de pago"
                                }),
                                redirecting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AssistantPaymentSwitch, {
                                                    label: "Enviar email",
                                                    loading: contentLoading
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AssistantPaymentSwitch, {
                                                    label: "Incluir costo de despacho",
                                                    loading: contentLoading
                                                })
                                            ]
                                        }),
                                        userHasCredits && /*#__PURE__*/ (0,jsx_runtime.jsx)(MekiCredits, {
                                            loading: loadingMethod
                                        }),
                                        showCreditsOrInsuranceInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsuranceInfoDiv, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PickUpOptions_styles/* InfoIconButton */.JE, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceInfoTypography, {
                                                    children: "Los Cr\xe9ditos Meki no pueden utilizarse junto a un seguro."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceOptions, {
                                            loadingInsurances: loadingInsurances,
                                            loadingCircle: loadingGetInsuranceQuote,
                                            loadInsuranceQuote: loadInsuranceQuote,
                                            mekiCreditsChecked: !showInsuranceOptions,
                                            userInsurances: (ref29 = insurancesData === null || insurancesData === void 0 ? void 0 : insurancesData.getUserInsurances) !== null && ref29 !== void 0 ? ref29 : [],
                                            quoteError: insuranceQuoteError
                                        }),
                                        showInsuranceInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceInfo, {
                                            productsWithInsuranceQuantity: productsWithInsuranceQuantity,
                                            orderDetailsAmount: orderDetailsAmount,
                                            payAmount: payAmount
                                        }),
                                        (quoteLoading || payAmount > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions/* PaymentsOptions */.C, {
                                            loading: contentLoading,
                                            quoteLoading: quoteLoading,
                                            handleNext: handleNext
                                        })
                                    ]
                                }),
                                !isDesktop && showNextButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* SubmitButton */.Mm, {
                                    disabled: contentLoading,
                                    onClick: function() {
                                        return handleNext();
                                    },
                                    children: "Siguiente"
                                })
                            ]
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary/* OrderSummary */.H, {
                            isDelivery: isDelivery,
                            deliveryCost: deliveryCost,
                            oldDeliveryCost: oldDeliveryCost,
                            handleNext: showNextButton ? handleNext : undefined,
                            loading: contentLoading
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(39425);
;// CONCATENATED MODULE: ./pages/checkout/metodo-pago/index.tsx



function CheckoutPaymentMethod() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* SEOHead */.R, {
                title: "Meki \xb7 Metodo de pago"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutPaymentMethodPage, {})
        ]
    });
}


/***/ }),

/***/ 19906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ps": function() { return /* binding */ StyledSkeleton; },
/* harmony export */   "q4": function() { return /* binding */ CardSkeleton; }
/* harmony export */ });
/* unused harmony export MarginSkeleton */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91655);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 5px;\n  padding: 0px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 15px 0px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CardSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a")(function(param) {
    var theme = param.theme, listLength = param.listLength;
    var _obj;
    return _obj = {
        width: "200px",
        minWidth: "151px",
        minHeight: "199px",
        border: "1px solid #EAEAEA",
        borderWidth: "0px 1px 1px 0px",
        textDecoration: "none",
        scrollSnapAlign: "start",
        position: "relative",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        padding: "17px 15px"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(320), {
        width: "".concat(Math.max(100 / listLength, 50), "%"),
        minWidth: 150
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(470), {
        width: "".concat(Math.max(100 / listLength, 33.3), "%")
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(620), {
        width: "".concat(Math.max(100 / listLength, 25), "%")
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(770), {
        width: listLength > 3 ? "33.3%" : 200,
        minWidth: 200
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(820), {
        width: listLength > 4 ? "25%" : 200
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(1020), {
        width: listLength > 5 ? "20%" : 200
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(1220), {
        width: 200
    }), _obj;
});
var StyledSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject());
var MarginSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1());



/***/ }),

/***/ 8002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ FREE_SECOND_SHIPPING_MIN_AMOUNT; },
/* harmony export */   "Nd": function() { return /* binding */ GOOGLE_RATING; },
/* harmony export */   "fI": function() { return /* binding */ DELIVERY_COST; },
/* harmony export */   "qM": function() { return /* binding */ SECOND_DELIVERY_COST; },
/* harmony export */   "yP": function() { return /* binding */ FREE_SHIPPING_MIN_AMOUNT; }
/* harmony export */ });
var FREE_SHIPPING_MIN_AMOUNT = 35000;
var FREE_SECOND_SHIPPING_MIN_AMOUNT = 70000;
var DELIVERY_COST = 3490;
var SECOND_DELIVERY_COST = 990;
var GOOGLE_RATING = 4.8;


/***/ }),

/***/ 3618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ usePendingPrescriptions; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/queries/order/queries/currentOrderWithPrescriptions.ts
var currentOrderWithPrescriptions = __webpack_require__(3073);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/prescription/queries/lookForPrescriptions.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LookForPrescription {\n    lookForPrescriptions {\n      prescriptionRequired\n      associations {\n        orderDetail {\n          id\n          product {\n            id\n            prescriptionType\n          }\n          quantity\n        }\n        prescriptionId\n        prescription {\n          id\n          url\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lookForPrescriptions = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
;// CONCATENATED MODULE: ./src/hooks/usePendingPrescriptions.ts





function usePendingPrescriptions() {
    var ref, ref1, ref2;
    var appUser = (0,useAuth/* useAuth */.a)().appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var ref3 = (0,useQuery/* useQuery */.a)((0,currentOrderWithPrescriptions/* currentOrderWithPrescriptions */.l)(), {
        returnPartialData: true,
        fetchPolicy: "cache-and-network",
        skip: !appUser
    }), prescriptionsData = ref3.data, prescriptionsLoading = ref3.loading;
    var productsWithPrescription = prescriptionsData === null || prescriptionsData === void 0 ? void 0 : (ref = prescriptionsData.currentOrder) === null || ref === void 0 ? void 0 : ref.orderDetails.filter(function(detail) {
        return detail.product.prescriptionType;
    }).map(function(detail) {
        return detail.product;
    });
    var ref4 = (0,useQuery/* useQuery */.a)(lookForPrescriptions(), {
        fetchPolicy: "cache-and-network",
        skip: !appUser
    }), lookForPrescriptionsData = ref4.data, prescriptionRequiredLoading = ref4.loading;
    var ref5;
    if (isLocalVendor || isAssistantUser) return {
        requirePrescriptions: false,
        enoughAssociationsFound: true,
        requirePrescriptionUpload: false,
        loading: false,
        pendingPrescriptions: (ref5 = prescriptionsData === null || prescriptionsData === void 0 ? void 0 : prescriptionsData.pendingPrescriptions) !== null && ref5 !== void 0 ? ref5 : [],
        associatedPrescriptions: []
    };
    var ref6;
    var requirePrescriptions = (ref6 = productsWithPrescription === null || productsWithPrescription === void 0 ? void 0 : productsWithPrescription.length) !== null && ref6 !== void 0 ? ref6 : 0;
    var requirePrescriptionUpload = productsWithPrescription === null || productsWithPrescription === void 0 ? void 0 : productsWithPrescription.some(function(product) {
        return product.prescriptionType !== "NOT_REQUIRED";
    });
    var ref7;
    var associationsAmount = (ref7 = lookForPrescriptionsData === null || lookForPrescriptionsData === void 0 ? void 0 : (ref1 = lookForPrescriptionsData.lookForPrescriptions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.associations) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref7 !== void 0 ? ref7 : 0;
    var enoughAssociationsFound = associationsAmount == requirePrescriptions;
    var ref8, ref9;
    return {
        requirePrescriptions: requirePrescriptions,
        enoughAssociationsFound: enoughAssociationsFound,
        requirePrescriptionUpload: requirePrescriptionUpload,
        loading: prescriptionsLoading || prescriptionRequiredLoading,
        pendingPrescriptions: (ref8 = prescriptionsData === null || prescriptionsData === void 0 ? void 0 : prescriptionsData.pendingPrescriptions) !== null && ref8 !== void 0 ? ref8 : [],
        associatedPrescriptions: (ref9 = lookForPrescriptionsData === null || lookForPrescriptionsData === void 0 ? void 0 : lookForPrescriptionsData.lookForPrescriptions.associations.map(function(association) {
            return association.prescription;
        })) !== null && ref9 !== void 0 ? ref9 : []
    };
}


/***/ }),

/***/ 66003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getCheckoutPaymentMethod; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: summary.ts
 * Project: meki
 * File Created: Thursday, 11th November 2021 10:55:35 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 1st December 2023 11:26:34 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query getCheckoutPaymentMethod($params: CurrentOrderParams) {\n    currentOrder(params: $params) {\n      id\n      uuid\n      orderGroupId\n      deliveryCost\n      metadata {\n        useMekiCredits\n        installments\n        payments {\n          amount\n          type\n        }\n        userInfo {\n          email\n          name\n          rut\n        }\n        sendEmail\n        insuranceInfo {\n          insuranceId\n          totalReimbursement\n          totalDeductible\n          reimbursedProducts {\n            sku\n            observation\n            unitReimbursement\n            unitCopay\n            unitDeductible\n            coverage\n          }\n        }\n        localVendor {\n          paymentMethod\n          mixPayments\n        }\n        assistantVendor {\n          paymentMethod\n        }\n        chargeDeliveryCost\n      }\n      paymentMethod {\n        id\n        uuid\n        type\n        data\n      }\n      address {\n        id\n        name\n        street\n        streetNumber\n        commune\n      }\n    }\n    paymentMethods {\n      id\n      uuid\n      type\n      data\n    }\n    currentUserInfo {\n      credits\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getCheckoutPaymentMethod = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 3073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ currentOrderWithPrescriptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query currentOrderWithPrescriptions($params: CurrentOrderParams) {\n    currentOrder(params: $params) {\n      id\n      orderDetails {\n        id\n        quantity\n        price\n        product {\n          id\n          name\n          imagesUrl\n          unit\n          format\n          concentration\n          laboratory\n          prescriptionType\n          availability {\n            stock\n            statusWithoutStock\n            status\n          }\n        }\n        status\n        prescription {\n          id\n        }\n      }\n    }\n    pendingPrescriptions {\n      id\n      uuid\n      url\n    }\n    currentUserInfo {\n      id\n      createdAt\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var currentOrderWithPrescriptions = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 20641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getUserInsurances; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetUserInsurances($params: GetUserInsurancesParams!) {\n    getUserInsurances(params: $params) {\n      id\n      rut\n      idUrl1\n      idUrl2\n      userId\n      name\n      usedAt\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getUserInsurances = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 54760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GL": function() { return /* binding */ InfoDiv; },
/* harmony export */   "JE": function() { return /* binding */ InfoIconButton; },
/* harmony export */   "mh": function() { return /* binding */ InfoTypography; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);


var InfoDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    alignItems: "center",
    padding: "10px 10px 10px 22px",
    backgroundColor: "#E6F3FA",
    marginTop: "12px"
});
var InfoIconButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    padding: "0",
    marginRight: "17px",
    color: "#414046"
});
var InfoTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "15.6px",
    letterSpacing: "0.15px",
    color: "#414046"
});



/***/ }),

/***/ 82031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useAssistantPaymentActions; },
/* harmony export */   "S": function() { return /* binding */ useAssistantPaymentOptions; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

var useAssistantPaymentOptionsStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()(function(set) {
    return {
        sendEmail: true,
        chargeDeliveryCost: true,
        actions: {
            setSendEmail: function(to) {
                set({
                    sendEmail: to
                });
            },
            setChargeDeliveryCost: function(to) {
                set({
                    chargeDeliveryCost: to
                });
            },
            cleanValues: function() {
                set({
                    sendEmail: true,
                    chargeDeliveryCost: true
                });
            }
        }
    };
});
var useAssistantPaymentOptions = function() {
    return useAssistantPaymentOptionsStore(function(state) {
        return {
            sendEmail: state.sendEmail,
            chargeDeliveryCost: state.chargeDeliveryCost
        };
    });
};
var useAssistantPaymentActions = function() {
    return useAssistantPaymentOptionsStore(function(state) {
        return state.actions;
    });
};


/***/ }),

/***/ 4999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getDeliveryCosts; }
/* harmony export */ });
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8002);

function getDeliveryCosts(item) {
    var usedDeliveryCoupons = item.orders.filter(function(order) {
        return order.deliveryCoupon;
    }).length;
    var totalCost = item.orders[0].totalCost;
    var productsCost = totalCost - item.deliveryCost;
    var oldDeliveryCost = item.orders.length === 2 ? usedDeliveryCoupons === 2 ? _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .DELIVERY_COST */ .fI + _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SECOND_DELIVERY_COST */ .qM : usedDeliveryCoupons === 1 ? productsCost < _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FREE_SHIPPING_MIN_AMOUNT */ .yP ? _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .DELIVERY_COST */ .fI + _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SECOND_DELIVERY_COST */ .qM : productsCost < _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FREE_SECOND_SHIPPING_MIN_AMOUNT */ .Gr ? _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SECOND_DELIVERY_COST */ .qM : null : null : item.orders.length === 1 ? usedDeliveryCoupons === 1 ? productsCost < _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FREE_SHIPPING_MIN_AMOUNT */ .yP ? _config_constants__WEBPACK_IMPORTED_MODULE_0__/* .DELIVERY_COST */ .fI : null : null : null;
    return {
        oldDeliveryCost: oldDeliveryCost,
        deliveryCost: item.deliveryCost
    };
}


/***/ }),

/***/ 47440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fh": function() { return /* binding */ SkeletonContainer; },
/* harmony export */   "KI": function() { return /* binding */ AllInsurancesContainer; },
/* harmony export */   "Ws": function() { return /* binding */ AddInsuranceButton; },
/* harmony export */   "X2": function() { return /* binding */ Row; },
/* harmony export */   "XU": function() { return /* binding */ InsuranceCardText; },
/* harmony export */   "Y_": function() { return /* binding */ InsuranceCardTitle; },
/* harmony export */   "p_": function() { return /* binding */ InsuranceContainer; },
/* harmony export */   "sY": function() { return /* binding */ DeleteIconContainer; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87843);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);


var AllInsurancesContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "10px",
    gap: "10px",
    alignItems: "center"
});
var InsuranceContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    backgroundColor: "white",
    borderRadius: "10px",
    border: "1px solid #EAEAEA",
    padding: "10px"
});
var InsuranceCardTitle = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    display: "flex",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "21px",
    width: "100%"
});
var InsuranceCardText = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    display: "flex",
    fontFamily: "Poppins",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#757475"
});
var Row = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between"
});
var DeleteIconContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button")({
    display: "flex",
    justifyContent: "flex-end",
    cursor: "pointer",
    background: "transparent",
    borderWidth: "0px"
});
var AddInsuranceButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "transparent",
    width: "fit-content",
    borderRadius: "20px",
    border: "none",
    color: "#0A7ABE",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    cursor: "pointer"
});
var SkeletonContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: 12,
    width: "100%",
    padding: "10px",
    border: "1px solid #EAEAEA",
    borderRadius: "10px"
});



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,4322,2510,7284,5103,4895,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(25426); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);